import * as rootAppBarActions from "./rootAppBarActions";
import * as rootAuthActions from "./rootAuthActions";
import * as rightDrawerActions from "./rightDrawerActions";

export const rootActions = {
  ...rootAppBarActions,
  ...rightDrawerActions,
  ...rootAuthActions,
};
